var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 13.875C3.70304 13.875 0.625 10.797 0.625 7C0.625 3.20304 3.70304 0.125 7.5 0.125C11.297 0.125 14.375 3.20304 14.375 7C14.375 10.797 11.297 13.875 7.5 13.875ZM7.5 12.625C10.6066 12.625 13.125 10.1066 13.125 7C13.125 3.8934 10.6066 1.375 7.5 1.375C4.3934 1.375 1.875 3.8934 1.875 7C1.875 10.1066 4.3934 12.625 7.5 12.625ZM7.5 7.88388L5.44194 9.94194L4.55806 9.05806L6.61612 7L4.55806 4.94194L5.44194 4.05806L7.5 6.11612L9.55806 4.05806L10.4419 4.94194L8.38388 7L10.4419 9.05806L9.55806 9.94194L7.5 7.88388Z",
    fill: "#97000C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcon);
export default __webpack_public_path__ + "static/media/rejected-icon.9fd168d0d0f5f78012240e05fed39782.svg";
export { ForwardRef as ReactComponent };